import { Typography, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Header = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "@media (max-width: 600px)": {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const DangerIcon = styled("img")(() => ({
  fontSize: "24px",
  color: colors.rose500,
  "@media (max-width: 600px)": {
    fontSize: "20px",
  },
}));

export const ModalContainer = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: "520px",
  backgroundColor: colors.white,
  borderRadius: "8px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "@media (max-width: 600px)": {
    width: "90%",
  },
}));

export const TitleText = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "22px",
  lineHeight: "28px",
  fontStyle: "normal",
  letterSpacing: "0.25px",
  fontWeight: 700,
  flexGrow: 1,
  textAlign: "center",
  "@media (max-width: 600px)": {
    fontSize: "18px",
    lineHeight: "24px",
  },
}));

export const Content = styled(Typography)(() => ({
  fontSize: "16px",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  "@media (max-width: 600px)": {
    fontSize: "14px",
    lineHeight: "20px",
  },
}));

export const Footer = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  "@media (max-width: 600px)": {
    justifyContent: "center",
    gap: "4px",
  },
}));

export const StyledButtonLogout = styled(Button)(() => ({
  color: colors.gray600,
  textTransform: "none",
  "&::first-letter": {
    textTransform: "capitalize",
  },
  fontFamily: "Manrope",
  "&:hover": {
    backgroundColor: colors.white,
  },
  "@media (max-width: 600px)": {
    fontSize: "14px",
  },
}));

export const StyledButtonStayLogIn = styled(Button)(() => ({
  color: colors.white,
  fontFamily: "Manrope",
  textTransform: "none",
  "&::first-letter": {
    textTransform: "capitalize",
  },
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  textAlign: "center",
  backgroundColor: colors.error500,
  "&:hover": {
    backgroundColor: colors.error500,
  },
  "@media (max-width: 600px)": {
    fontSize: "12px",
    padding: "8px 12px",
  },
}));

const useStyles = makeStyles(() => ({
  mainDiv: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
  },
  container: {
    height: "100%",
    width: "100%",
    margin: "0 auto",
    background: colors.white,
    borderRadius: 0,
  },
  rightBox: {
    flex: 1,
    background: colors.white,
    display: "flex",
    padding: "48px",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    height: "100%",
    width: "100%",
    "@media (max-width: 600px)": {
      padding: "32px",
    },
    "@media (min-width: 1200px)": {
      padding: "64px",
    },
  },
  leftBox: {
    width: "100%",
    height: "100%",
    background: "transparent",
    margin: "0 auto",
    padding: 0,
  },
}));

export default useStyles;
